import { initialStateT, modalName } from '../reducers/Settings';

export const getModalInfoByName = (name: modalName) => (state: any) => {
  const dataState: initialStateT = state.Configurations;
  const result = dataState.modalState.modalList[name];
  return result;
};

export const getModalParametersByName = (state: any) => {
  const dataState: initialStateT = state.Configurations;
  const result = dataState.modalState.modalInfo;
  return result;
};

export const getActualAttributes = (state: any) => {
  const dataState: initialStateT = state.Configurations;
  const result = dataState.attributes;
  return result;
};

export const getActualAttributesByName = (name: any) => (state: any) => {
  const dataState: any = state.Configurations;

  const result = dataState['attributes'][name];
  return result;
};

export const getActualPriceById = (state: any) => {
  const dataState: any = state.Configurations;
  const result = dataState['priceInfo'];
  return result;
};

export const getActualpriceAdditional = (state: any) => {
  const dataState: any = state.Configurations;
  const result = dataState['priceAdditional'];
  return result;
};

export const getConfigInfo = (state: any) => {
  const dataState: any = state.Configurations;
  const result = dataState['configInfo'];
  return result;
};
